import { render, staticRenderFns } from "./GestioneMaterie.vue?vue&type=template&id=bdf562d0&scoped=true"
import script from "./GestioneMaterie.vue?vue&type=script&lang=js"
export * from "./GestioneMaterie.vue?vue&type=script&lang=js"
import style0 from "./GestioneMaterie.vue?vue&type=style&index=0&id=bdf562d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf562d0",
  null
  
)

export default component.exports